import PropTypes from 'prop-types';
import { useUserDeletedStatus, useUserProfile } from '../../../slice';
import { ImgUserPlaceholder, Utility } from '../../rootAccess';
import ProfileImage from '../ProfileImage';

function UserProfileImage({ userId, className = '' }) {
    // Call hooks unconditionally (hooks must be called in the same order every render)
    const { colorCode, nickName, image } = useUserProfile(userId) || {};
    const userDeletedStatus = useUserDeletedStatus(userId);

    // Handle undefined userId by showing a black circle
    if (!userId) {
        return (
            <svg
                className={className}
                viewBox="0 0 100 100"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <circle fill="#000000" cx="50" cy="50" r="50" />
            </svg>
        );
    }

    const initialName = Utility.getInitialsFromName(nickName || userId);
    const imageUri = userDeletedStatus ? '' : image;

    if (image || userDeletedStatus) {
        return (
            <ProfileImage
                className={className}
                imageUri={imageUri}
                userId={userId}
                defaultImg={ImgUserPlaceholder}
                alt="User"
            />
        );
    }

    return (
        <svg
            className={className}
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <circle fill={colorCode} cx="50" cy="50" r="50" />
            <text dominantBaseline="central" fill="#fff" fontSize="24pt" textAnchor="middle" x="50" y="50">
                {initialName}
            </text>
        </svg>
    );
}

export default UserProfileImage;

UserProfileImage.propTypes = {
    userId: PropTypes.string, // Made optional to handle undefined gracefully
    className: PropTypes.string,
};
